module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c174b10aafffd565094.worker.js");
};